import type { AutoSaveOperation } from '../hooks/useAutoSave';

export interface ScheduleConfigurationSaveData {
  scheduleId: string;
  name: string;
  is_public: boolean;
  configuration: unknown;
  is_primary: boolean;
  classes?: readonly string[];
}
interface ConfigurationSaveConsumer {
  ownerId: string;
  primaryScheduleId: string | null;
  writeSchedule: (id: string, updates: Record<string, unknown>) => Promise<unknown>;
  writePrimary: (id: string) => Promise<unknown>;
  publishSchedule: (ownerId: string, id: string, updates: Record<string, unknown>) => void;
  publishPrimary: (id: string) => void;
  publishSaved: () => void;
}

/** Each continuation is authorized independently; a dispatched write keeps its original target. */
export async function saveScheduleConfiguration(
  data: ScheduleConfigurationSaveData,
  operation: AutoSaveOperation,
  consumer: ConfigurationSaveConsumer,
): Promise<void> {
  if (!operation.isCurrent()) return;
  const updates = JSON.parse(JSON.stringify({ scheduleId: data.scheduleId, name: data.name,
    is_public: data.is_public, configuration: data.configuration,
    ...(data.classes === undefined ? {} : { classes: [...data.classes] }),
  })) as Record<string, unknown>;
  await consumer.writeSchedule(data.scheduleId, JSON.parse(JSON.stringify(updates)));
  if (!operation.isCurrent()) return;
  consumer.publishSchedule(consumer.ownerId, data.scheduleId, updates);
  if (data.is_primary && consumer.primaryScheduleId !== data.scheduleId) {
    if (!operation.isCurrent()) return;
    await consumer.writePrimary(data.scheduleId);
    if (!operation.isCurrent()) return;
    consumer.publishPrimary(data.scheduleId);
  }
  if (!operation.isCurrent()) return;
  consumer.publishSaved();
}

/** Consuming the add-course command keeps the same configuration destination. */
export function getConfigurationAutosaveRouteKey(pathname: string | null, query: string): string {
  const parameters = new URLSearchParams(query);
  parameters.delete('add');
  return JSON.stringify([pathname, parameters.toString()]);
}
